import type { QueryClient } from "@tanstack/react-query";
import { prefetchLocationCoverMedia } from "./prefetchLocationCoverMedia";
import { prefetchTeacherProfileMedia } from "./prefetchTeacherProfileMedia";

export async function prefetchPublicTeacherListingMedia(
  queryClient: QueryClient,
  tenantId: number,
  teacherIds: number[],
): Promise<void> {
  const ids = teacherIds.filter((id) => id > 0);
  await Promise.all(
    ids.map((teacherId) =>
      prefetchTeacherProfileMedia(queryClient, tenantId, teacherId),
    ),
  );
}

export async function prefetchPublicLocationListingMedia(
  queryClient: QueryClient,
  tenantId: number,
  locationIds: number[],
): Promise<void> {
  const ids = locationIds.filter((id) => id > 0);
  await Promise.all(
    ids.map((locationId) =>
      prefetchLocationCoverMedia(queryClient, tenantId, locationId),
    ),
  );
}
